<div class="center-unregister center">
  <div class="center-container center center-vertically" *ngIf="!visitors || visitors.length === 0 && visitorsLoaded">
    <div class="grid-container-no-visitors">

      <h1 class="no-visitors">Momenteel zijn er geen geregistreerde bezoekers</h1>
      <p>
        u kunt een erkend bezoeker worden door u te registreren.
      </p>

      <app-custom-btn customClass="button pattern shadow larger" class="bottom" [routerLink]="'/main/register'">
        <mat-icon>dialpad</mat-icon>
        Aanmelden
        <mat-icon>person_add</mat-icon>
      </app-custom-btn>
    </div>
  </div>
  <div class="center-container" *ngIf="visitors && visitors.length > 0">
    <div class="banner">
      <h1 class="banner-text">
        <mat-icon>touch_app</mat-icon>
        Selecteer jezelf om je af te melden!
        <mat-icon>touch_app</mat-icon>
      </h1>
    </div>
    <div class="center" id="back-button">
      <app-custom-btn customClass="back" (click)="goBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </app-custom-btn>
    </div>
    <div class="grid-container">
      <mat-card *ngFor="let item of visitors" class="my-card1 pattern shadow selectable-row"
                (click)="deleteSelected(item)" [class.selected]="selectedItem === item">
        <div class="half-border">
          <mat-card-header class="card-overflow">
            <mat-card-title>
              {{ item?.name.length > 18 ? item?.name.substring(0, 18).trimEnd() + '...' : item?.name }}
            </mat-card-title>
          </mat-card-header>
        </div>
      </mat-card>
    </div>
  </div>
</div>
